/**
 * Teeinblue "added to cart" toast -> open the theme cart drawer.
 *
 * Teeinblue's app shows its own success message after add-to-cart:
 *   "This item has been added to cart! <a href="<shop>/cart">View cart</a>"
 * (rendered inside its Vue UI, e.g. `.tee-success`). Clicking "View cart" does a
 * full-page navigation to /cart. This store uses a slide-out cart drawer, so we
 * intercept that click and open the drawer instead — matching the theme's own
 * add-to-cart behaviour. Only links inside Teeinblue's UI are affected; the
 * theme's own /cart links (e.g. the header cart) are left untouched.
 */
(function () {
  function getThemeDrawer() {
    var el = document.getElementById('cart-drawer') || document.querySelector('cart-drawer-component');
    return el && el.closest ? el.closest('theme-drawer') : null;
  }

  function isCartPageHref(anchor) {
    try {
      var url = new URL(anchor.href, window.location.href);
      if (url.host !== window.location.host) return false;
      var path = url.pathname.replace(/\/+$/, '');
      // Matches "/cart" and locale/market-prefixed variants like "/en-us/cart".
      return /(^|\/)cart$/.test(path);
    } catch (e) {
      return false;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var anchor = target.closest('a[href]');
      if (!anchor || !isCartPageHref(anchor)) return;

      // Only hijack links rendered inside Teeinblue's own UI (its success toast).
      if (!anchor.closest('[class*="tee-"], #teeinblue-wrapper')) return;

      var drawer = getThemeDrawer();
      if (!drawer || typeof drawer.open !== 'function') return; // no drawer -> let it navigate

      event.preventDefault();
      event.stopPropagation();
      if (!drawer.isOpen) drawer.open();
    },
    true // capture phase: run before Teeinblue's handler and before navigation
  );
})();
